import { render } from "./ProjectTitle.vue?vue&type=template&id=65604ad0"
import script from "./ProjectTitle.vue?vue&type=script&lang=js"
export * from "./ProjectTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__